"use client";

import { useState } from "react";
import Image from "next/image";
import { Container } from "./Primitives";

const NAV = [
  { label: "Услуги", href: "#services" },
  { label: "Автомобили", href: "#cars" },
  { label: "Мероприятия", href: "#events" },
  { label: "Достижения", href: "#achievements" },
  { label: "О нас", href: "#about" },
  { label: "Контакты", href: "#contacts" },
];

const PHONE = "+7 495 108-48-48";
const PHONE_TEL = PHONE.replace(/[^\d+]/g, "");

/**
 * Header — sticky-less top bar on white card.
 * Desktop: logo | nav links | phone.
 * Mobile: logo | burger; burger opens vertical menu.
 * Логотип состоит из двух картинок (mark + text) — это паттерн из TagJS.
 */
export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-white">
      <Container className="py-5 sm:py-7 lg:py-9">
        <div className="flex items-center justify-between gap-6">
          {/* Logo */}
          <a href="#top" className="flex items-center gap-3 shrink-0">
            <Image
              src="/img/tagjs/49lrdhbt.png"
              alt="AUTOPILOT.COMPANY"
              width={44}
              height={45}
              className="h-9 w-auto sm:h-10 lg:h-[45px]"
              priority
            />
            <Image
              src="/img/tagjs/7yo78qky.png"
              alt=""
              width={177}
              height={33}
              className="h-6 w-auto sm:h-7 lg:h-[33px]"
              priority
            />
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8 xl:gap-10 text-[15px] text-text">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="transition hover:text-primary"
              >
                {n.label}
              </a>
            ))}
          </nav>

          {/* Desktop phone */}
          <a
            href={`tel:${PHONE_TEL}`}
            className="hidden lg:flex items-center gap-2 text-[15px] text-text transition hover:text-primary"
          >
            <Image src="/img/tagjs/neirryzc.png" alt="" width={28} height={28} />
            <span className="whitespace-nowrap">{PHONE}</span>
          </a>

          {/* Mobile burger */}
          <button
            type="button"
            aria-label={menuOpen ? "Закрыть меню" : "Открыть меню"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden inline-flex size-10 items-center justify-center rounded-md transition hover:bg-bg"
          >
            <Image
              src="/img/tagjs/wayng0vz.png"
              alt=""
              width={24}
              height={24}
            />
          </button>
        </div>

        {/* Mobile menu sheet */}
        {menuOpen && (
          <nav className="lg:hidden mt-4 flex flex-col gap-3 border-t border-black/10 pt-4 text-[16px]">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setMenuOpen(false)}
                className="py-2 text-text transition hover:text-primary"
              >
                {n.label}
              </a>
            ))}
            <a
              href={`tel:${PHONE_TEL}`}
              className="mt-2 inline-flex items-center gap-2 py-2 text-text transition hover:text-primary"
            >
              <Image src="/img/tagjs/neirryzc.png" alt="" width={20} height={20} />
              {PHONE}
            </a>
          </nav>
        )}
      </Container>
    </header>
  );
}
